import { Link, Outlet, useNavigate} from "react-router"
import styles from "./Marketing.layout.module.css"
import logo from "@/assets/logo.svg"
import { useState, type ReactNode } from "react"
import Wrapper from "../components/wrapper/Wrapper"
import { User } from "lucide-react"
import UserSettings from "@/features/auth/user-settings/UserSettings"
import { useAuthLoaderData } from "@/loaders/auth/useAuthLoaderData"

type Props = {
  children?: ReactNode
}

export default function MarketingLayout({children} : Props) {    
  const navigate = useNavigate()
  const [isAuthSettingsActive, setAuthSettingsActive] = useState(false)

  const username = useAuthLoaderData()?.user?.name;    
  
  return (
    <div className={styles.layout}>
      <Wrapper bgColor="white">
        <nav className={styles.nav}>                       
          <div className={styles.logo}>
            <img src={logo} alt="logo" width={0} height={0}/> Proobi
          </div>

          <div className={styles.navlinks}></div>


          <div className={styles.auth}>
            <UserSettings isActive={isAuthSettingsActive} onBlur={() => setAuthSettingsActive(false)}/>
            <Link className={styles.login} to={username ? "/providers" : "/login"}>
              { username ? "Entrar al panel" : "Iniciar sesión" }
            </Link>                  
            <div className={styles.icon} onClick={() => username ? setAuthSettingsActive(!isAuthSettingsActive) : navigate("/login") }>                             
              { username ? username.charAt(0) : <User width={20} height={20}/> }              
            </div>            
          </div>
        </nav>      
      </Wrapper>
      {children ?? <Outlet />}      
    </div>
  )
}
